<script lang="ts" setup>
import { computed } from "vue";

import type { AchievementItemEffectType } from "@/common/types/vocab";

const props = defineProps<{
  effect: AchievementItemEffectType;
}>();

const effectUrl = computed(() => `/assets/img/vocab/achievements/effects/${props.effect}.png`);
</script>

<template>
  <div class="achievement-item-effect" :style="{ backgroundImage: `url(${effectUrl})` }"></div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.achievement-item-effect {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 5px;
  width: 51%;
  background-size: cover;

  #media-breakpoint-up(md, {
    width: 34%
  });
}
</style>
